import type { GQL } from "@binale-tech/shared";

import { DmsType, type IDocumentType } from "@domain/models/dms";

export interface CashRegisterFolder {
    cashRegisterId: string;
    name: string;
    subTypeId: string;
}

/** The Kasse subfolders of DMS bound to an existing cash register; unbound subfolders are left out. */
export const buildCashRegisterFolders = (
    documentTypes: IDocumentType[],
    registersById: ReadonlyMap<string, GQL.ICashRegister>,
): CashRegisterFolder[] =>
    (documentTypes.find((type) => type.id === DmsType.KB)?.subTypes ?? []).flatMap((subType) => {
        const register = subType.cashRegisterId ? registersById.get(subType.cashRegisterId) : undefined;
        return register ? [{ cashRegisterId: register.id, name: register.name, subTypeId: subType.id }] : [];
    });
